namespace Gamification.Gamification {
    export interface ProdottiRow {
        IdProdotto?: number;
        UserId?: number;
        TenantId?: number;
        IdTipologiaProdotti?: number;
        IdentifierProdotto?: string;
        Nome?: string;
        Descrizione?: string;
        Bozza?: number;
        IdentifierPunteggio?: string;
        PunteggioNome?: string;
        PunteggioValoreIniziale?: number;
        PunteggioNegativo?: number;
        IdentifierCrediti?: string;
        CreditiNome?: string;
        CreditiValoreIniziale?: number;
        IdentifierEsperienza?: string;
        EsperienzaNome?: string;
        EsperienzaValoreIniziale?: number;
        SMTPHost?: string;
        SMTPPort?: number;
        SMTPDisplayName?: string;
        SMTPFrom?: string;
        SMTPUsername?: string;
        SMTPPassword?: string;
        SMTPUseSsl?: number;
        SMTPUseStartTls?: number;
        SMTPSecureSocket?: string;
        OggettoCambiaPassword?: string;
        CorpoCambiaPassword?: string;
        OggettoCancellazione?: string;
        CorpoCancellazione?: string;
        OggettoRegistrazione?: string;
        CorpoRegistrazione?: string;
        LinkRegistrazione?: string;
        OggettoResetPassword?: string;
        CorpoResetPassword?: string;
        LinkResetPassword?: string;
        IsSMTPValido?: number;
        UserIdNominativo?: string;
        UserIdRagioneSociale?: string;
        IdTipologiaProdottiNome?: string;
        IdTipologiaProdottiDescrizione?: string;
        BadgeList?: ProdottiBadgeRow[];
        ClassiList?: ProdottiClassiRow[];
        EsperienzeList?: ProdottiEsperienzeRow[];
        LivelliList?: ProdottiLivelliRow[];
    }

    export namespace ProdottiRow {
        export const idProperty = 'IdProdotto';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.Prodotti';
        export const lookupKey = 'Gamification.Prodotti';

        export function getLookup(): Q.Lookup<ProdottiRow> {
            return Q.getLookup<ProdottiRow>('Gamification.Prodotti');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            IdProdotto = "IdProdotto",
            UserId = "UserId",
            TenantId = "TenantId",
            IdTipologiaProdotti = "IdTipologiaProdotti",
            IdentifierProdotto = "IdentifierProdotto",
            Nome = "Nome",
            Descrizione = "Descrizione",
            Bozza = "Bozza",
            IdentifierPunteggio = "IdentifierPunteggio",
            PunteggioNome = "PunteggioNome",
            PunteggioValoreIniziale = "PunteggioValoreIniziale",
            PunteggioNegativo = "PunteggioNegativo",
            IdentifierCrediti = "IdentifierCrediti",
            CreditiNome = "CreditiNome",
            CreditiValoreIniziale = "CreditiValoreIniziale",
            IdentifierEsperienza = "IdentifierEsperienza",
            EsperienzaNome = "EsperienzaNome",
            EsperienzaValoreIniziale = "EsperienzaValoreIniziale",
            SMTPHost = "SMTPHost",
            SMTPPort = "SMTPPort",
            SMTPDisplayName = "SMTPDisplayName",
            SMTPFrom = "SMTPFrom",
            SMTPUsername = "SMTPUsername",
            SMTPPassword = "SMTPPassword",
            SMTPUseSsl = "SMTPUseSsl",
            SMTPUseStartTls = "SMTPUseStartTls",
            SMTPSecureSocket = "SMTPSecureSocket",
            OggettoCambiaPassword = "OggettoCambiaPassword",
            CorpoCambiaPassword = "CorpoCambiaPassword",
            OggettoCancellazione = "OggettoCancellazione",
            CorpoCancellazione = "CorpoCancellazione",
            OggettoRegistrazione = "OggettoRegistrazione",
            CorpoRegistrazione = "CorpoRegistrazione",
            LinkRegistrazione = "LinkRegistrazione",
            OggettoResetPassword = "OggettoResetPassword",
            CorpoResetPassword = "CorpoResetPassword",
            LinkResetPassword = "LinkResetPassword",
            IsSMTPValido = "IsSMTPValido",
            UserIdNominativo = "UserIdNominativo",
            UserIdRagioneSociale = "UserIdRagioneSociale",
            IdTipologiaProdottiNome = "IdTipologiaProdottiNome",
            IdTipologiaProdottiDescrizione = "IdTipologiaProdottiDescrizione",
            BadgeList = "BadgeList",
            ClassiList = "ClassiList",
            EsperienzeList = "EsperienzeList",
            LivelliList = "LivelliList"
        }
    }
}
